import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Stack, Button } from '@mui/material';

// icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import DoneAllIcon from '@mui/icons-material/DoneAll';
// Tabela
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Iconify from '../../../components/iconify';

// api
import { validateUser, getOss, createOs } from '../../api';
import config from '../../../config.json';
import PopoverFiltro from '../../PopoverFiltroOs';
import ModalLoading from '../../ModalLoading';
import ModalConfirmacao from '../../ModalConfirmacao';
import Fluxo from '../Fluxograma/Fluxo';
import { useWebSocket } from '../../../contexts/WebSocketContext';
import { cores } from '../../../styles/styleUtils';

// ----------------------------------------------------------------------

export default function Cronograma() {
  const [propostas, setPropostas] = useState([]);
  const usuarioLogado = JSON.parse(localStorage.getItem('userData'));
  const [modalLoading, setModalLoading] = useState(false);
  const [openFiltro, setOpenFiltro] = useState(null);
  const emptyFiltro = {
    usuarioLogado,
    dataAgendamentoInicio: new Date()
      .toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      .split('/')
      .reverse()
      .join('-'),
    dataAgendamentoFim: new Date()
      .toLocaleDateString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      .split('/')
      .reverse()
      .join('-'),
    statusAgenda: ['Aberta'],
    status: ['Aberta', 'Atrasada'],
    unidades: [],
    classificacoes: [],
    responsaveis: usuarioLogado.supervisor ? [] : [usuarioLogado._id],
    fornecedores: [],
    distribuidoras: [],
    cronograma: true,
  };
  const [filtro, setFiltro] = useState({ ...emptyFiltro });
  const [modalConfirmacao, setModalConfirmacao ] = useState(false)

  const { unreadCount } = useWebSocket();
  const { chamadosCount, osCount } = unreadCount || { chamadosCount: 0, osCount: 0 };

  const fGetPropostas = useCallback(async (filtro) => {
    try {
      const result = await getOss(filtro);
      setPropostas(result);
    } catch (error) {
      window.alert('Erro ao consultar banco de dados');
      console.error('Erro ao buscar dados da API:', error);
    }
  }, []);

  useEffect(() => {
    fGetPropostas(filtro);
  }, [filtro, chamadosCount, osCount, fGetPropostas]);

  // Valida usuario
  const navigate = useNavigate();
  useEffect(() => {
    validateuser();
  }, []);
  const validateuser = async () => {
    const teste = await validateUser();
    if (!teste.ok) {
      localStorage.removeItem('userData');
      localStorage.removeItem('userToken');
      config.user = {};
      navigate('/', { replace: true });
      window.alert('Sessão expirada, faça o login novamente');
      return;
    }
    localStorage.setItem('userData', JSON.stringify(teste.usuario));
    config.user = teste.usuario;
  };
  // -------------
  // Outras funcoes e declaracoes
  // ---------------------
  // Modal
  const [open, setOpen] = useState(false);
  const [produto, setProduto] = useState(null);

  const handleClose = () => {
    setOpen(false);
    setProduto(null);
  };

  const onConfirmHandler = async (data) => {
    setModalLoading(true);
    try {
      const responseOs = await createOs(data);
      if (!responseOs || !responseOs.success) {
        window.alert(responseOs?.message || 'Erro ao salvar a OS. Tente novamente.');
      }
      if (responseOs.warning) {
        window.alert(
          'Erro ao enviar a mensagem automática para o cliente, verifique a conexão do WhatsApp e o telefone do cliente'
        );
      }
    } catch (error) {
      window.alert('Erro ao salvar a OS');
      console.log('error');
    }
    fGetPropostas(filtro);
    handleClose();
    setModalLoading(false);
  };

  // Filtro ----

  const onCloseFiltro = () => {
    setOpenFiltro(null);
  };

  const closeModalConfirmacaDelete = () => {
    setModalConfirmacao(false);
  };

  const handleDeleteClick = (row) => {
    setModalConfirmacao(row);
  };

  const limparFiltro = () => {
    setFiltro({ ...emptyFiltro });
    setOpenFiltro(null);
  };

  const onConfirmFiltro = (filtroPopover) => {
    setFiltro(filtroPopover);
    setOpenFiltro(null);
  };
  // Filtro ----

  const handleVisualiza = async (row) => {
    setModalLoading(true);
    const updateOs = { _id: row._id, abriuNotificacao: true };
    await createOs(updateOs);
    fGetPropostas(filtro);
    setProduto({ ...row, abriuNotificacao: true });
    setOpen(true);
    setModalLoading(false);
  };

  const handleFinalizarAgenda = async () => {
    setModalLoading(true);
    const updateOs = { _id: modalConfirmacao._id, statusAgenda: 'Finalizada' };
    await createOs(updateOs);
    fGetPropostas(filtro);
    closeModalConfirmacaDelete()
    setModalLoading(false);
  };

  // ----------------------

  return (
    <>
      <Helmet>
        <title> Cronograma </title>
      </Helmet>

      <Container maxWidth="xl">
        <Stack direction={'row'} justifyContent={'space-between'}>
          <Typography variant="h4" sx={{ mb: 5 }}>
            Cronograma
          </Typography>

          <Button
            onClick={(e) => setOpenFiltro(e.currentTarget)}
            variant="contained"
            startIcon={<Iconify icon="eva:search-fill" />}
            sx={{
              height: 50,
              minWidth: 100,
              backgroundColor: cores.laranja,
              marginLeft: 'auto',
              '&:hover': { backgroundColor: cores.laranjaEscuro },
            }}
          >
            Filtros
          </Button>
        </Stack>

        {/* ------------ Tabela ------------ */}
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="center">Unidade</TableCell>
                <TableCell align="center">Data</TableCell>
                <TableCell align="center">Classificação</TableCell>
                <TableCell align="center">OS</TableCell>
                <TableCell align="left">Responsável</TableCell>
                <TableCell align="center">Status</TableCell>
                <TableCell align="center">{''}</TableCell>
                <TableCell align="center">{''}</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {propostas.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    '&:last-child td, &:last-child th': { border: 0 },
                    ...(!row.abriuNotificacao && {
                      backgroundColor: 'Khaki',
                    }),
                    ...(row.status === 'Atrasada' && {
                      backgroundColor: 'Tomato',
                    }),
                  }}
                >
                  <TableCell align="left">{row.cliente?.nome}</TableCell>
                  <TableCell align="center">{row.unidade?.nome}</TableCell>
                  <TableCell align="center">
                    {new Date(row.dataAgendamento).toLocaleString('pt-BR', {
                      timeZone: 'America/Sao_Paulo', // Opcional: força o fuso BR mesmo se o usuário estiver fora
                    })}
                  </TableCell>
                  <TableCell align="center">{row.classificacao?.nome}</TableCell>
                  <TableCell align="center">{row.codigo}</TableCell>
                  <TableCell align="left">{row.responsavelExecucao?.nome}</TableCell>
                  <TableCell align="center">{row.status}</TableCell>
                  <TableCell align="center">
                    <Button
                      size="small"
                      variant="contained"
                      startIcon={<VisibilityIcon />}
                      onClick={() => handleVisualiza(row)}
                    >
                      Visualizar
                    </Button>
                  </TableCell>
                  {row.status !== 'Finalizada' && (
                    <TableCell align="center">
                      <Button
                        size="small"
                        variant="contained"
                        color={'success'}
                        startIcon={<DoneAllIcon />}
                        onClick={() => handleDeleteClick(row)}
                      >
                        Finalizar
                      </Button>
                    </TableCell>
                  )}
                </TableRow>
              ))}
              <TableRow>
                <TableCell align="left" colSpan={3}>
                  <strong>
                    Total: <strong>{propostas.length}</strong>
                  </strong>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Container>

      {openFiltro && (
        <PopoverFiltro
          filtro={filtro}
          open={openFiltro}
          onClose={onCloseFiltro}
          onLimpar={limparFiltro}
          onConfirm={onConfirmFiltro}
          type={'cronograma'}
        />
      )}
      {/* Modal Loading */}
      {modalLoading && <ModalLoading open={modalLoading} />}
      {open && <Fluxo open={open} proposta={produto} onClose={handleClose} onConfirm={onConfirmHandler} />}
      {modalConfirmacao && (
        <ModalConfirmacao
          title={'Tem certeza que deseja finalizar essa agenda?'}
          subtitle={`${modalConfirmacao.cliente?.nome} - ${new Date(modalConfirmacao.dataAgendamento).toLocaleDateString()} - ${modalConfirmacao.codigo}`}
          open={modalConfirmacao}
          onClose={closeModalConfirmacaDelete}
          onConfirm={handleFinalizarAgenda}
        />
      )}
    </>
  );
}